import { render, staticRenderFns } from "./ProgressBadge.vue?vue&type=template&id=770654ad&"
import script from "./ProgressBadge.vue?vue&type=script&lang=js&"
export * from "./ProgressBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports